<template>
  <div id="sidebar">
    <!-- Sidebar -->
    <div class="sidebar-fixed position-fixed">
      <a href="../index.html" class="logo-wrapper waves-effect">
        <!-- <img
          src="../../assets/images/docker.png"
          width="140"
          class="img-fluid"
          alt="dawini dz"
        /> -->
        <h3 class="text-white">Carixin Llc</h3>
      </a>

      <div class="list-group list-group-flush">
        <div class="nav flex-column nav-pills">
          <router-link
            class="nav-link list-group-item waves-effect"
            :class="{
              active: routeName == '/dashboard',
            }"
            @click="changed()"
            to="/dashboard"
            ><i class="fas fa-home mr-md-3"></i
            ><span class="d-none d-md-inline-block">Home</span></router-link
          >
          <!-- <router-link
            class="nav-link list-group-item waves-effect"
            to="profile"
            :class="{
              active: routeName == '/profile',
            }"
            @click="changed()"
            ><i class="fas fa-user mr-md-3"></i
            ><span class="d-md-inline-block">Profiles</span></router-link
          > -->
          <router-link
            class="nav-link list-group-item waves-effect"
            to="/users"
            :class="{
              active: routeName == '/users',
            }"
            @click="changed()"
            ><i class="fas fa-user mr-md-3"></i
            ><span class="d-md-inline-block">Users</span></router-link
          >
          <router-link
            class="nav-link list-group-item waves-effect"
            :class="{
              active: routeName == `/messages`,
            }"
            @click="changed()"
            to='messages'
          >
            <i class="fas fa-list-alt mr-md-3"></i
            ><span class="d-none d-md-inline-block">Messages</span></router-link
          >
          <router-link
            class="nav-link list-group-item waves-effect"
            :class="{
              active: routeName == '/shops',
            }"
            @click="changed()"
            to="/shops"
          >
            <i class="fas fa-list-alt mr-md-3"></i
            ><span class="d-none d-md-inline-block">Shops</span>
          </router-link>
          <router-link
            class="nav-link list-group-item waves-effect"
            :class="{
              active: routeName == '/services',
            }"
            @click="changed()"
            to="/services"
          >
            <i class="fas fa-list-alt mr-md-3"></i
            ><span class="d-none d-md-inline-block">Services</span>
          </router-link>
          <router-link
            class="nav-link list-group-item waves-effect"
            :class="{
              active: routeName == '/orders',
            }"
            @click="changed()"
            to="/orders"
          >
            <i class="fas fa-list-alt mr-md-3"></i
            ><span class="d-none d-md-inline-block">Orders</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "Sidebar",
  data() {
    return {
      routeName: this.$route.path,
    };
  },
  computed: {
    user(){
      return this.$store.state.user;
    }
  },
  watch: {
    $route(to) {
      this.routeName = to.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-fixed {
  height: 100vh;
  width: 270px;
  margin-top: 56px;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
    0 2px 10px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 100;
  background-color: #000dff;
  padding: 0 1.5rem 1.5rem;
  top: 0;
  .list-group .active {
    -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
      0 2px 10px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16),
      0 2px 10px 0 rgba(0, 0, 0, 0.12);
    -webkit-border-radius: 5px;
    border-radius: 5px;
  }
  .logo-wrapper {
    padding: 2.5rem;
    img {
      max-height: 50px;
    }
  }
}

@media (min-width: 1200px) {
}
@media (max-width: 1199.98px) {
  .sidebar-fixed {
    display: none;
  }
  .page-footer,
  main {
    padding-left: 270px;
  }
}
</style>